import Vue from 'vue'
import { ToastPlugin, ModalPlugin } from 'bootstrap-vue'
import VueCompositionAPI from '@vue/composition-api'
import CKEditor from '@ckeditor/ckeditor5-vue2'
import datePicker from '@alireza-ab/vue-persian-datepicker'

import i18n from '@/libs/i18n'
import Vuelidate from 'vuelidate'
import appInstance from './app-instance'
import router from './router'
import store from './store'
import App from './App.vue'

// Global Components
import './global-components'
import '../themeConfig'

// 3rd party plugins
import '@axios'
import '@/libs/acl'
import '@/libs/portal-vue'
import '@/libs/clipboard'
import '@/libs/toastification'
import '@/libs/sweet-alerts'
import '@/libs/vue-select'

// BSV Plugin Registration
Vue.use(ToastPlugin)
Vue.use(ModalPlugin)
Vue.use(CKEditor)

// Composition API
Vue.use(VueCompositionAPI)
Vue.use(require('vue-jalali-moment'))

Vue.component('DatePicker', datePicker)

Vue.use(Vuelidate)
// Feather font icon - For form-wizard
// * Shall remove it if not using font-icons of feather-icons - For form-wizard
require('@core/assets/fonts/feather/iconfont.css') // For form-wizard

// import core styles
require('@core/scss/core.scss')

// import assets styles
require('@/assets/scss/style.scss')

Vue.config.productionTip = false

Vue.mixin({
  methods: {
    createSlug: title => {
      let slug = ''
      // Change to lower case
      const titleLower = title.toLowerCase()
      // Letter "e"
      slug = titleLower.replace(/e|é|è|ẽ|ẻ|ẹ|ê|ế|ề|ễ|ể|ệ/gi, 'e')
      // Letter "a"
      slug = slug.replace(/a|á|à|ã|ả|ạ|ă|ắ|ằ|ẵ|ẳ|ặ|â|ấ|ầ|ẫ|ẩ|ậ/gi, 'a')
      // Letter "o"
      slug = slug.replace(/o|ó|ò|õ|ỏ|ọ|ô|ố|ồ|ỗ|ổ|ộ|ơ|ớ|ờ|ỡ|ở|ợ/gi, 'o')
      // Letter "u"
      slug = slug.replace(/u|ú|ù|ũ|ủ|ụ|ư|ứ|ừ|ữ|ử|ự/gi, 'u')
      // Letter "d"
      slug = slug.replace(/đ/gi, 'd')
      // Trim the last whitespace
      slug = slug.replace(/\s*$/g, '')
      // Change whitespace to "-"
      slug = slug.replace(/\s+/g, '-')

      return slug
    },
    createFullFileAddress({
      baseUrl,
      bucketName,
      destination,
      filename,
    }) {
      return `${baseUrl + bucketName}/${destination}${filename}`
    },
  },
})

const app = new Vue({
  router,
  store,
  i18n,
  render: h => h(App),
}).$mount('#app')

appInstance.current = app

export default app
